import { isServer } from '@/shared/util/ssr';
import { LocalStorageKey } from '../LocalStorageKey';

export function getHiddenTopNotificationIds(): string[] {
  if (isServer) {
    return [];
  }

  try {
    const hiddenTopNotificationIdsString =
      localStorage.getItem(LocalStorageKey.HiddenTopNotificationIds) || '[]';

    return JSON.parse(hiddenTopNotificationIdsString);
  } catch (error) {
    if (error) {
      //
    }
    return [];
  }
}

export function setHiddenTopNotificationId(hiddenTopNotificationId: string) {
  if (isServer) {
    return;
  }

  try {
    const hiddenTopNotificationIds = new Set(getHiddenTopNotificationIds());
    hiddenTopNotificationIds.add(hiddenTopNotificationId);

    localStorage.setItem(
      LocalStorageKey.HiddenTopNotificationIds,
      JSON.stringify(Array.from(hiddenTopNotificationIds)),
    );
  } catch (error) {
    if (error) {
      //
    }
  }
}
